function r({ list: n, rng: o = Math.random }) {
  return n[Math.floor(o() * n.length)];
}
export {
  r as randomItem
};
//# sourceMappingURL=index3.js.map
